import { HomeLayout } from "../../shared/layout/HomeLayout";
import { useService } from "@infrastructure/api/hooks/use-service";
import { Requests } from "@infrastructure/api/requests";
import { NewsLetter } from "@presentation/pages/home/NewsLetter";
import { Offers } from "@presentation/pages/home/Offers";
import { useExtraTab } from "@presentation/shared/context/extra-tab-context";

function HomePage() {
  const { data: offers } = useService(Requests.offers, true);
  const { slug } = useExtraTab();

  return (
    <HomeLayout>
      {slug ? (
        <div className="min-h-[600px]"></div>
      ) : (
        <>
          <Offers offers={offers} />
          <NewsLetter />
        </>
      )}
    </HomeLayout>
  );
}

export default HomePage;
